import {
  getStoreSlotOrder,
  formatParticipantDisplayName,
  getResolvedSlotAssignments,
} from '../events';

export const COLS_PER_STORE = 2;
export const GAP_COLS = 1;
export const BLOCK_WIDTH = COLS_PER_STORE + GAP_COLS;

function participantName(participants, responseId) {
  if (!responseId) return null;
  const participant = participants.find((entry) => entry.responseId === responseId);
  return participant ? formatParticipantDisplayName(participant) : null;
}

function slotParticipantLabel(store, slot, assignments, participants) {
  const slotAssignments = getResolvedSlotAssignments(store, slot, assignments, participants);
  if (slotAssignments.length === 0) return '—';
  return slotAssignments
    .map((assignment) => {
      const participant = participants.find((entry) => entry.responseId === assignment.responseId);
      return participant ? formatParticipantDisplayName(participant) : '—';
    })
    .join(', ');
}

export function buildStoreBlocks(event, participants) {
  return event.stores.map((store) => {
    const meta = [];
    const leader = participantName(participants, store.leaderResponseId);
    const vice = participantName(participants, store.viceLeaderResponseId);
    if (leader) meta.push(`Responsabile: ${leader}`);
    if (vice) meta.push(`Vice: ${vice}`);
    if (store.notes) meta.push(`Note: ${store.notes}`);

    const rows = getStoreSlotOrder(store, event.slots).map((slot) => [
      slot,
      slotParticipantLabel(store, slot, event.assignments, participants),
    ]);

    return { name: store.name, meta, rows };
  });
}

export function buildSideBySideMatrix(blocks, startRow = 0) {
  if (blocks.length === 0) {
    return {
      matrix: [['Nessun negozio configurato']],
      merges: [],
      layout: { startRow, headerRowIdx: startRow, dataStartIdx: startRow + 1, maxDataRows: 0 },
    };
  }

  const maxMeta = Math.max(...blocks.map((block) => block.meta.length), 0);
  const maxDataRows = Math.max(...blocks.map((block) => block.rows.length), 0);
  const headerRowIdx = startRow + 1 + maxMeta;
  const dataStartIdx = headerRowIdx + 1;
  const totalRows = dataStartIdx + maxDataRows;
  const totalCols = blocks.length * BLOCK_WIDTH - GAP_COLS;

  const matrix = Array.from({ length: totalRows }, () => Array(totalCols).fill(''));
  const merges = [];

  blocks.forEach((block, index) => {
    const columnStart = index * BLOCK_WIDTH;
    const titleRow = startRow;

    matrix[titleRow][columnStart] = block.name;
    merges.push({
      r0: titleRow,
      c0: columnStart,
      r1: titleRow,
      c1: columnStart + 1,
    });

    block.meta.forEach((line, metaIndex) => {
      const row = startRow + 1 + metaIndex;
      matrix[row][columnStart] = line;
      merges.push({
        r0: row,
        c0: columnStart,
        r1: row,
        c1: columnStart + 1,
      });
    });

    matrix[headerRowIdx][columnStart] = 'Fascia oraria';
    matrix[headerRowIdx][columnStart + 1] = 'Partecipante';

    block.rows.forEach((rowValues, rowIndex) => {
      matrix[dataStartIdx + rowIndex][columnStart] = rowValues[0];
      matrix[dataStartIdx + rowIndex][columnStart + 1] = rowValues[1];
    });
  });

  return {
    matrix,
    merges,
    layout: { startRow, headerRowIdx, dataStartIdx, maxDataRows },
  };
}

export function getEventExportBasename(event) {
  return `turni_${(event.name || 'evento').replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '_')}`;
}
